"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basemain = void 0;
exports.basemain = {
    "addresses": {
        "CreateCall": "0x7cbB62EaA69F79e6873cD1ecB2392971036cFAa4",
        "ProxyAdmin": "0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x59dF33EBf2101d93d2878a82ad1A0959a58bCcEB",
        "FeedPriceOracle": "0x94fFeFF526BECce69bCc0578995AAC73983b4c7b",
        "CompLogic": "0x5EA97142b444c6eC5791a5f1C24A1265Aa1FA40C",
        "RedemptionManager": "0xfebaB92dE1F2BFAADc63c920CDf8F9a5449ED841",
        "Timelock": "0x99B96511F4F0EBe6254c8f1BaE8FAc565A54eb7E",
        "Comptroller": "0x3F2B7C60A7bb8f2dbb779Ad14aA0A5614f008d3b",
        "sdrETH": "0x2AA93D3142d7327307b770Dba2e87C97b86B95Bc",
        "ETH": "0x0000000000000000000000000000000000000000",
        "CErc20": "0xC157f665da751B6B60207F2248f000B0A67608Da",
        "suErc20": "0x64b975dED78B731e91c789571f48fC050aaA61e7",
        "stUSDAdapter": "0xCC727419975308db748c950EBCeC7Bb478A1c771",
        "stEURAdapter": "0xDeD795A8Cf0784265a3A90613Ad675879a0660b6",
        "JumpRate#StableBC": "0xA9Ea90899fA648b4Ce49f6aE28174AEAda660118",
        "JumpRate#Others": "0xaB883FF9EF68F54CcECe0249C48Ba1Dd65265F1c",
        "JumpRate#wstETH": "0xCFDA1c9910fC074681f9D6E80b53736719fB91Cb",
        "JumpRate#BTCBC_AltStables": "0xFeb721c719B5859760BCD4a497Ee5a3EA85F1cC1",
        "ZeroRate": "0x49Be9bBFF2a5B8A005cfb1C41c01515f7F4ebf82",
        "JumpRate#ETH": "0x3069B06324aAfC0a97Fb4186FCAD9F5fB22eeB59",
        "sdrUSDC": "0x142017b52c99d3dFe55E49d79Df0bAF7F4478c0c",
        "USDC": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        "sdrUSDbc": "0x3389eD4dd777b03B95deb2994ACaF6807cf24c2E",
        "USDbc": "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
        "sdrDAI": "0xA4578AB5CDA88AaE7603aFAB24b4c0d24a7858D1",
        "DAI": "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
        "sdrstUSD": "0x7b1D6dda0cB59c0c87a3d07e97a66e23aE3aF969",
        "stUSD": "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
        "sdrwstETH": "0x238d804Cb1F4c0c7495e7b7773c54D75E4C99cdd",
        "wstETH": "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
        "sdrcbETH": "0x6345aF6dA3EBd9DF468e37B473128Fd3079C4a4b",
        "cbETH": "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
        "sdrweETH": "0xb330cae9C6207dF60C2785b29F775DEC0FE20026",
        "weETH": "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
        "sdrcbBTC": "0x0BAd894e6c094Ee78924982b09eE54B6e24Af7F1",
        "cbBTC": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        "sdrEURC": "0x6f06a771104F22B006037313954Ef289a1f26Ddd",
        "EURC": "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
        "sdrstEUR": "0xdf1d98A8A1439D348949c72Abf3f678e8B0BF87b",
        "stEUR": "0x004626A008B1aCdC4c74ab51644093b155e59A23",
        "sdrsuUSD": "0xa1aD8481e83a5b279D97ab371bCcd5AE3b446EA6",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuETH": "0x56048C88309CAF13A942d688bfB9654432910d6e",
        "suETH": "0x1c22531aa9747d76fff8f0a43b37954ca67d28e0"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x142017b52c99d3dFe55E49d79Df0bAF7F4478c0c",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDbc",
            "ctokenAddr": "0x3389eD4dd777b03B95deb2994ACaF6807cf24c2E",
            "underlySym": "USDbc",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrDAI",
            "ctokenAddr": "0xA4578AB5CDA88AaE7603aFAB24b4c0d24a7858D1",
            "underlySym": "DAI",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrstUSD",
            "ctokenAddr": "0x7b1D6dda0cB59c0c87a3d07e97a66e23aE3aF969",
            "underlySym": "stUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrwstETH",
            "ctokenAddr": "0x238d804Cb1F4c0c7495e7b7773c54D75E4C99cdd",
            "underlySym": "wstETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xc1CBa3fCea344f92D9239c08C0568f6F2F0ee452",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrcbETH",
            "ctokenAddr": "0x6345aF6dA3EBd9DF468e37B473128Fd3079C4a4b",
            "underlySym": "cbETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrweETH",
            "ctokenAddr": "0xb330cae9C6207dF60C2785b29F775DEC0FE20026",
            "underlySym": "weETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x04C0599Ae5A44757c0af6F9eC3b93da8976c150A",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrcbBTC",
            "ctokenAddr": "0x0BAd894e6c094Ee78924982b09eE54B6e24Af7F1",
            "underlySym": "cbBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrEURC",
            "ctokenAddr": "0x6f06a771104F22B006037313954Ef289a1f26Ddd",
            "underlySym": "EURC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrstEUR",
            "ctokenAddr": "0xdf1d98A8A1439D348949c72Abf3f678e8B0BF87b",
            "underlySym": "stEUR",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x004626A008B1aCdC4c74ab51644093b155e59A23",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0xa1aD8481e83a5b279D97ab371bCcd5AE3b446EA6",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x56048C88309CAF13A942d688bfB9654432910d6e",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1c22531aa9747d76fff8f0a43b37954ca67d28e0",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x2AA93D3142d7327307b770Dba2e87C97b86B95Bc",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#ETH",
            "contract": "JumpRateModelV2",
            "address": "0x3069B06324aAfC0a97Fb4186FCAD9F5fB22eeB59",
            "tokens": [
                "ETH",
                "ETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.036",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0xA9Ea90899fA648b4Ce49f6aE28174AEAda660118",
            "tokens": [
                "USDC",
                "USDbc",
                "DAI",
                "EURC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.8"
        },
        {
            "name": "JumpRate#BTCBC_AltStables",
            "contract": "JumpRateModelV2",
            "address": "0xFeb721c719B5859760BCD4a497Ee5a3EA85F1cC1",
            "tokens": [
                "stUSD",
                "cbBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0889",
            "jumpMultiplierPerYear": "5.52727",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0xaB883FF9EF68F54CcECe0249C48Ba1Dd65265F1c",
            "tokens": [
                "wstETH",
                "cbETH",
                "weETH",
                "stEUR"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x49Be9bBFF2a5B8A005cfb1C41c01515f7F4ebf82",
            "tokens": [
                "suUSD",
                "suETH"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=basemain.js.map